import RendConf from './components/app/RendConf';

// A rendezvény ikonjának URL-je: <api>/getIcon/<rendezvényID> (az api/ikon.php szolgálja ki; nem közvetlen fájlhivatkozás).
// A "verzio" (pl. a tárolt fájlnév) csak a böngésző-gyorsítótár frissítésére szolgál.
export function ikonURL(rendezvenyID, verzio) {
    const alap = (RendConf.url_api || '/api/index.php').replace(/[^/]*$/, '');
    return alap + 'getIcon/' + encodeURIComponent(rendezvenyID) + (verzio ? '?v=' + encodeURIComponent(verzio) : '');
}

// Kép átméretezése a böngészőben a feltöltés előtt: a hosszabbik oldal legfeljebb maxOldal pixel.
// Az átlátszóságot hordozó formátumok (PNG, GIF, WEBP) PNG-ként, a JPEG JPEG-ként megy tovább.
// kesz(dataURL) vagy hiba(szoveg).
export function kepAtmeretezes(fajl, maxOldal, kesz, hiba) {
    const olvaso = new FileReader();
    olvaso.onerror = function () { hiba('A fájl nem olvasható.'); };
    olvaso.onload = function () {
        const kep = new Image();
        kep.onerror = function () { hiba('Ez a fájl nem kép, vagy nem támogatott formátumú.'); };
        kep.onload = function () {
            const nagyobb = Math.max(kep.width, kep.height);
            if (nagyobb <= maxOldal && fajl.size <= 300 * 1024 && /^image\/(png|jpeg|gif|webp)$/.test(fajl.type)) {
                kesz(String(olvaso.result));   // eleve elég kicsi
                return;
            }
            const arany = Math.min(1, maxOldal / nagyobb);
            const vaszon = document.createElement('canvas');
            vaszon.width = Math.max(1, Math.round(kep.width * arany));
            vaszon.height = Math.max(1, Math.round(kep.height * arany));
            const ctx = vaszon.getContext('2d');
            const jpeg = fajl.type === 'image/jpeg';
            if (jpeg) {
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, vaszon.width, vaszon.height);
            }
            ctx.drawImage(kep, 0, 0, vaszon.width, vaszon.height);
            let eredmeny = vaszon.toDataURL(jpeg ? 'image/jpeg' : 'image/png', 0.9);
            if (eredmeny.length * 0.75 > 900 * 1024) {
                // túl nagy PNG: JPEG, fehér háttérrel
                const feher = document.createElement('canvas');
                feher.width = vaszon.width;
                feher.height = vaszon.height;
                const c2 = feher.getContext('2d');
                c2.fillStyle = '#ffffff';
                c2.fillRect(0, 0, feher.width, feher.height);
                c2.drawImage(vaszon, 0, 0);
                eredmeny = feher.toDataURL('image/jpeg', 0.85);
            }
            kesz(eredmeny);
        };
        kep.src = String(olvaso.result);
    };
    olvaso.readAsDataURL(fajl);
}
